export const API_URL = 'https://hungry-bhaskara.154-68-232-27.plesk.page/api'
// export const API_URL = 'http://localhost:8000/api';
// export const API_URL = 'https://arikcareer.irescue.app/api';
